import Network from 'infrastructure/js/modules/network';

export function fetchShelfLifeUpdateReasons(query={}) {
  return Network.post('reason-types/items', query);
}
